/* ============================================================
   SAÉA — Magazine issue behaviour
   Ported from the approved prototype (sayah-campaign/index.html).

   Differences from the prototype:
   - The cart is REAL: Shopify AJAX Cart API (/cart/add.js, /cart.js, /cart/change.js)
     instead of the prototype's in-memory mock.
   - The season/year dateline is rendered server-side in Liquid from
     article.published_at, so there's no flash of placeholder text.
   ============================================================ */
(function () {
  'use strict';

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- hover shim: apply [style-hover] on mouseenter ---------- */
  function bindHovers(root) {
    $$('[style-hover]', root).forEach(function (el) {
      if (el._hb) return;
      el._hb = true;
      var base = el.getAttribute('style') || '';
      var hov = el.getAttribute('style-hover') || '';
      el.addEventListener('mouseenter', function () { el.setAttribute('style', base + ';' + hov); });
      el.addEventListener('mouseleave', function () { el.setAttribute('style', base); });
    });
  }

  /* ---------- money ---------- */
  function money(cents) {
    var v = cents / 100;
    return '$' + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2));
  }

  /* ---------- cart (Shopify AJAX Cart API) ---------- */
  var cartOpen = false;
  var busy = false;

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }

  function addToCart(variantId) {
    if (busy) return;
    busy = true;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    })
      .then(function () { return getCart(); })
      .then(function (cart) { cartOpen = true; activeHotspot = null; renderCart(cart); renderHotspots(); })
      .catch(function () { /* sold out / unavailable — leave the page as-is */ })
      .then(function () { busy = false; });
  }

  function changeLine(key, qty) {
    if (busy) return;
    busy = true;
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); })
      .then(function () { busy = false; });
  }

  function lineHTML(item) {
    var img = item.image
      ? item.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_160x$1$2')
      : '';
    var sub = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
    return '' +
      '<div style="display:flex;gap:14px;padding:18px 0;border-bottom:1px solid var(--saea-rule)">' +
        '<div style="width:66px;height:66px;flex:none;border-radius:4px;overflow:hidden;background:var(--saea-bg-3)">' +
          (img ? '<img src="' + img + '" alt="" style="width:100%;height:100%;object-fit:cover">' : '') +
        '</div>' +
        '<div style="flex:1;min-width:0">' +
          '<div style="display:flex;justify-content:space-between;gap:10px">' +
            '<div style="font-family:var(--saea-display);font-style:italic;font-weight:300;font-size:17px;color:var(--saea-ink);line-height:1.2">' + item.product_title + '</div>' +
            '<button data-remove="' + item.key + '" aria-label="Remove" style="background:none;border:none;cursor:pointer;color:var(--saea-ink-soft);padding:0;flex:none">' +
              '<svg width="14" height="14" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
            '</button>' +
          '</div>' +
          (sub ? '<div style="font-family:\'JetBrains Mono\',monospace;font-size:10px;letter-spacing:.12em;text-transform:uppercase;color:var(--saea-ink-soft);margin-top:3px">' + sub + '</div>' : '') +
          '<div style="display:flex;align-items:center;justify-content:space-between;margin-top:12px">' +
            '<div style="display:flex;align-items:center;gap:2px;border:1px solid var(--saea-rule);border-radius:999px;padding:3px">' +
              '<button data-dec="' + item.key + '" aria-label="Decrease" style="width:24px;height:24px;border-radius:999px;background:transparent;border:none;color:var(--saea-ink);cursor:pointer;display:grid;place-items:center">' +
                '<svg width="11" height="11" viewBox="0 0 12 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M1 6h10"/></svg>' +
              '</button>' +
              '<span style="min-width:22px;text-align:center;font-family:\'JetBrains Mono\',monospace;font-size:13px;color:var(--saea-ink)">' + item.quantity + '</span>' +
              '<button data-inc="' + item.key + '" aria-label="Increase" style="width:24px;height:24px;border-radius:999px;background:transparent;border:none;color:var(--saea-ink);cursor:pointer;display:grid;place-items:center">' +
                '<svg width="11" height="11" viewBox="0 0 12 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M6 1v10M1 6h10"/></svg>' +
              '</button>' +
            '</div>' +
            '<span style="font-family:var(--saea-display);font-style:italic;font-size:18px;color:var(--saea-ink)">' + money(item.line_price) + '</span>' +
          '</div>' +
        '</div>' +
      '</div>';
  }

  function renderCart(cart) {
    var count = cart.item_count;
    var box = $('#cartItems');
    if (box) {
      box.innerHTML = cart.items.map(lineHTML).join('');
      bindHovers(box);
    }

    $$('[data-when="hasItems"]').forEach(function (el) { el.style.display = count > 0 ? '' : 'none'; });
    $$('[data-when="isEmpty"]').forEach(function (el) { el.style.display = count > 0 ? 'none' : ''; });

    var cs = $('[data-count]'); if (cs) cs.textContent = count;
    var st = $('[data-subtotal]'); if (st) st.textContent = money(cart.total_price);

    var drawer = $('.sayah-drawer'), scrim = $('.sayah-scrim');
    if (drawer && scrim) {
      if (cartOpen) { drawer.classList.add('open'); scrim.classList.add('open'); }
      else { drawer.classList.remove('open'); scrim.classList.remove('open'); }
    }
  }

  /* ---------- shoppable hotspots ---------- */
  var activeHotspot = null;
  function renderHotspots() {
    $$('[data-pop]').forEach(function (el) {
      el.style.display = el.getAttribute('data-pop') === activeHotspot ? '' : 'none';
    });
  }

  /* ---------- delegated clicks ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest(
      '[data-add],[data-hot],[data-open-cart],[data-close-cart],[data-remove],[data-inc],[data-dec]'
    );
    if (!t) return;

    if (t.hasAttribute('data-add')) {
      e.preventDefault();
      addToCart(t.getAttribute('data-add'));
    } else if (t.hasAttribute('data-hot')) {
      var k = t.getAttribute('data-hot');
      activeHotspot = activeHotspot === k ? null : k;
      renderHotspots();
    } else if (t.hasAttribute('data-open-cart')) {
      cartOpen = true; getCart().then(renderCart);
    } else if (t.hasAttribute('data-close-cart')) {
      cartOpen = false; getCart().then(renderCart);
    } else if (t.hasAttribute('data-remove')) {
      changeLine(t.getAttribute('data-remove'), 0);
    } else if (t.hasAttribute('data-inc')) {
      var inc = t.closest('div').querySelector('span');
      changeLine(t.getAttribute('data-inc'), parseInt(inc.textContent, 10) + 1);
    } else if (t.hasAttribute('data-dec')) {
      var dec = t.closest('div').querySelector('span');
      changeLine(t.getAttribute('data-dec'), parseInt(dec.textContent, 10) - 1);
    }
  });

  /* ---------- reveal / stagger / parallax ---------- */
  function setupMotion() {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!reduce) {
      var solo = $$('[data-reveal]');
      solo.forEach(function (e) { e.classList.add('rv'); });
      var groups = $$('[data-stagger]');
      groups.forEach(function (g) {
        Array.prototype.slice.call(g.children).forEach(function (c, i) {
          c.classList.add('rv');
          c.style.transitionDelay = i * 85 + 'ms';
        });
      });
      var targets = solo.concat(groups);
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (ents) {
          ents.forEach(function (en) {
            if (en.isIntersecting) {
              if (en.target.hasAttribute('data-stagger')) {
                Array.prototype.slice.call(en.target.children).forEach(function (c) { c.classList.add('in'); });
              } else {
                en.target.classList.add('in');
              }
              io.unobserve(en.target);
            }
          });
        }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
        targets.forEach(function (e) { io.observe(e); });
      } else {
        solo.forEach(function (e) { e.classList.add('in'); });
        groups.forEach(function (g) {
          Array.prototype.slice.call(g.children).forEach(function (c) { c.classList.add('in'); });
        });
      }
    }

    var px = $$('[data-parallax]');
    if (px.length && !reduce) {
      var onScroll = function () {
        var vh = window.innerHeight;
        px.forEach(function (el) {
          var r = el.parentElement.getBoundingClientRect();
          var prog = (r.top + r.height / 2 - vh / 2) / vh;
          el.style.transform = 'translate3d(0,' + prog * -26 + 'px,0)';
        });
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  }

  /* ---------- the portfolio row ----------
     Desktop: vertical scroll drives a horizontal slide, blended so it begins
     LEAD_VH before the row pins and finishes TAIL_PX after it unpins.
     Mobile (<880px): no scroll-jack at all — a native swipe carousel.        */
  function setupGallery() {
    var outer = $('#sayahGallery'), track = $('#sayahTrack');
    if (!outer || !track) return;

    var LEAD_VH = 0.3, TAIL_PX = 90;
    var isMobile = function () { return window.matchMedia('(max-width:879px)').matches; };

    var measure = function () {
      if (isMobile()) { outer.style.height = ''; track.style.transform = ''; outer._dist = 0; return; }
      var dist = Math.max(0, track.scrollWidth - window.innerWidth);
      outer._dist = dist;
      outer.style.height = window.innerHeight + dist + 'px';
      update();
    };

    var update = function () {
      if (isMobile()) return;
      var dist = outer._dist || 0;
      if (dist <= 0) { track.style.transform = 'translate3d(0,0,0)'; return; }
      var top = outer.getBoundingClientRect().top;
      var lead = window.innerHeight * LEAD_VH, tail = TAIL_PX;
      var p = (lead - top) / (lead + dist + tail);
      p = Math.min(Math.max(p, 0), 1);
      var e = p * p * (3 - 2 * p); // smoothstep — ramps in, ramps out
      track.style.transform = 'translate3d(' + -(e * dist) + 'px,0,0)';
    };

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', measure);
    measure();
    setTimeout(measure, 120);
    window.addEventListener('load', measure);
  }

  /* ---------- bag pill: sits below the masthead at the top, rises after ---------- */
  function setupBagPill() {
    var pill = $('[data-open-cart]');
    if (!pill) return;
    var header = $('.magazine-masthead');
    var hh = header ? Math.round(header.getBoundingClientRect().height) : 44;
    pill.style.transition = 'top .42s cubic-bezier(.4,0,.2,1), background .3s, transform .4s';
    var apply = function () { pill.style.top = (window.scrollY > hh - 6 ? 22 : hh + 14) + 'px'; };
    window.addEventListener('scroll', apply, { passive: true });
    window.addEventListener('resize', function () {
      hh = header ? Math.round(header.getBoundingClientRect().height) : 44;
      apply();
    });
    apply();
  }

  function init() {
    setupBagPill();
    renderHotspots();
    bindHovers(document);
    setupMotion();
    setupGallery();
    getCart().then(renderCart);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
